import React, { useState } from "react";
import KeyboardEventHandler from "react-keyboard-event-handler";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Block";
import Typography from "@material-ui/core/Typography";

import { StyledCoverOverlay } from "./common.styles";

const KeyboardCoverOverlay = () => {
  const [showOverlay, setShowOverlay] = useState(false);

  return (
    <>
      <KeyboardEventHandler
        handleKeys={["meta", "ctrl", "shift", "shift+ctrl", "shift+meta"]}
        onKeyEvent={(key, e) => setShowOverlay(true)}
      />
      {showOverlay && (
        <StyledCoverOverlay onContextMenu={(e) => e.preventDefault()}>
          <CloseIcon color="primary" style={{ fontSize: "72px" }} />
          <Box mb={1} />
          <Typography>This action is not allowed</Typography>
          <Box mb={1} />
          <Button
            variant="contained"
            color="primary"
            onClick={() => setShowOverlay(false)}
          >
            Close
          </Button>
        </StyledCoverOverlay>
      )}
    </>
  );
};

export default KeyboardCoverOverlay;
